// extracted by mini-css-extract-plugin
module.exports = {"gplay":"MobileApp_gplay__Hz9-u","appstore":"MobileApp_appstore__2fAEV"};